import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import * as moment from 'moment';
import {IntlServicePP} from 'src/common/intl/services/intl.service';
import {LogManager} from "../../log/log.manager";
import {LogCat} from "../../log/log.categories";
import {Idle} from "@ng-idle/core";
import { SelfSchedulingDataService } from 'src/app-main/self.scheduling/services';


const propraietrayToJson = function() {
  return moment(this).format('YYYY-MM-DD\\THH:mm:ss.SSS');
};

const datesParser = function reviver(key, value) {
  const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}$/;
  if (typeof value === "string" && dateFormat.test(value)) {
    return new Date(value);
  }
  return value;
};


export interface IPatientPortalMessage {
  action: string;
  extraData: any;
}


@Component({
  selector: 'app-web-form-light-container',
  templateUrl: './web.form.light.container.component.html',
  styleUrls: ['./web.form.light.container.component.scss']
})
export class WebFormLightContainerComponent implements OnInit {

  @ViewChild('Iframe', {static: false}) Iframe: ElementRef;
  @Output() dataValidated = new EventEmitter();
  @Output() webClientFormLoaded = new EventEmitter();
  @Input() waitForPatientWhichRequiresOrderInit:boolean;

  public IFrameSrc: SafeResourceUrl;
  private webFormURL: string;
  private selectedLanguageCode: string;

  private webFormReady = false;
  private patientObj:any;
  private patientStr:any;
  //private waitingPatientPrepPromise:Promise<any>;
  private waitingPatientPrepPromiseResolve:(patient:any)=>void;
  private waitingPatientPrepPromiseReject:(Error)=>void;
  private requestId:number;

  constructor(private sanitizer: DomSanitizer,
              private changeDetector: ChangeDetectorRef,
              private intlServicePP: IntlServicePP,
              private idle: Idle,
              private selfSchedulingDataService: SelfSchedulingDataService) {
  }

  ngOnInit(): void {
    if (window.addEventListener) {
      window.addEventListener('message', this.receiveMessageFromIFrame.bind(this), false);
    } else {
      (window as any).attachEvent('onmessage', this.receiveMessageFromIFrame.bind(this));
    }
  }

  private sendMessageToWebFormFrame(msg: IPatientPortalMessage) {
    LogManager.debug(LogCat.Comm.WebClient,'sending message to web client ', msg);
    const iframeDocument = this.Iframe.nativeElement.contentWindow;
    if (iframeDocument) {
      iframeDocument.postMessage(msg, '*');
    }
  }

  public patientForSave(){
    if (this.waitingPatientPrepPromiseReject){
      this.waitingPatientPrepPromiseReject(new Error('called for patientForSave with waiting patient promise'));
      this.waitingPatientPrepPromiseReject=null;
      this.waitingPatientPrepPromiseResolve=null;
    }
    let promise = new Promise((resolve,reject) => {
        this.waitingPatientPrepPromiseResolve=resolve;
        this.waitingPatientPrepPromiseReject = reject;
    });
    this.requestId=Date.now();
    this.sendMessageToWebFormFrame({action:'PREP_FOR_SAVE',extraData:{patient:this.serializePatient(this.patient),reqId:this.requestId}});
    return promise;
  }

  public get patient(){
    if (!this.patientObj && this.patientStr){
      this.patientObj=JSON.parse(this.patientStr,datesParser);
    }
    return this.patientObj;
  }

  public set patient(pat:any){
    this.setData(pat,true);
    this.patientObj=pat;
  }

  public set patientString(pat :string){
    this.patientObj=undefined;
    this.patientStr=pat;
  }

  public sendKeyPressCharToForm(key:string){
    this.sendMessageToWebFormFrame({action:'KEYBOARD_CHAR_PRESSED',extraData:key});
  }

  @Input()
  set URL(url: string) {
    this.webFormURL = url;
    this.intlServicePP.getUsedLanguageObservable().subscribe(lang => {
      if (lang) {
        if (this.selectedLanguageCode !== lang.code) {
          this.selectedLanguageCode = lang.code;
          this.setUrl(this.webFormURL, lang.code);
        }
      }
    });
  }


  public setData(patient: any, requireOrderInit:boolean) {
    if (!this.webFormReady){
      this.patientObj=patient;
    }else {
      if (patient) {
        this.sendMessageToWebFormFrame({
          action: 'SET_PATIENT',
          extraData: this.serializePatient({patient, requireOrderInit})
        });
      } else {
        this.sendMessageToWebFormFrame({action: 'EMPTY_PATIENT', extraData: undefined});
      }
    }
  }

  private serializePatient(patient:any){
    if (Date.prototype.toJSON !== propraietrayToJson){
      Date.prototype.toJSON = propraietrayToJson;
    }
    return JSON.stringify(patient);
  }

  private setUrl(url: string, languageCode: string) {
    url = url + (languageCode? '&langCode=' + languageCode:'');
    this.IFrameSrc =this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.changeDetector.markForCheck();
  }

  private receiveMessageFromIFrame(event: MessageEvent) {
    const iframeDocument = this.Iframe.nativeElement.contentWindow;
    if (event.source === iframeDocument) {
      // idle service was not aware of changes inside iframe
      this.idle.watch();
      LogManager.debug(LogCat.Comm.WebClient,'received message from web client ', event);
       if (event.data) {
         const message: IPatientPortalMessage = event.data;
         switch (message.action) {
           case 'READY':
             this.webFormReady = true;
             if (!this.waitForPatientWhichRequiresOrderInit || this.patient){
               this.setData(this.patient,this.waitForPatientWhichRequiresOrderInit);
             }
             this.webClientFormLoaded.emit();
          break;
           case 'PATIENT_FOR_SAVE':
             let patient=message.extraData.p;
             let requestId = message.extraData.reqId;
             if (this.requestId === requestId){
               this.waitingPatientPrepPromiseResolve(patient);
               this.waitingPatientPrepPromiseResolve=null;
               this.waitingPatientPrepPromiseReject=null;
               this.requestId=null;
             }else{
               LogManager.warn(LogCat.Comm.WebClient,"received reply for old request when new is available",requestId,this.requestId);
             }
           break;
          case 'PATIENT_DATA_VALIDATED':
            this.dataValidated.emit(message.extraData);
            break;
           case 'DATA':
             if (typeof message.extraData ==="string"){
               this.patientString = message.extraData;
             }else{
               LogManager.error(LogCat.Comm.WebClient,"received invalid data type for patient",message.extraData)
             }
             break;
           case 'WINDOW_ACTIVITY':
             // nothing to do
             break;
           case 'POPSTATE_NAVIGATION':
             // Trigger opening the navigation popup
             this.selfSchedulingDataService.navigationConfirmationPopupSubject.next();
             break;
           default:
             LogManager.error(LogCat.Comm.WebClient,"unknown action",message.action);
             break;
         }
      }
    }
    /*else{
      LogManager.debug(LogCat.Comm.WebClient,'message from another iframe');
    }*/
  }
}
